import React, { useState, useEffect, useRef, useTransition, useMemo } from "react";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import AdjustWhModal from "../../../components/Modal/AdjustWhModal";
import Pagination from "../../../components/Pagination";

// Utils
import {
  getDataWithComp,
  getAlert,
  formatCurrency,
  parseCurrency,
} from "../../../../utils/SamuiUtils";

import { formatDateAndTime, formatUTCDateAndTime } from "../../../../utils/DateUtils";
import moment from "moment";
import { submitItems } from "../../../../utils/services";
import ProductModal from "../../../components/Modal/ProductModal";

import {
  ExportInventories,
  ExportInventoriesWarehouse,
} from "../../../../utils/ExportUtils";

import { manageWhItemData } from "../../../../utils/WarehouseUtils";
import ItemModal from "../../../components/Modal/ItemModal";

import { Button } from "antd";

const sanitizeNumeric = (raw) => {
  let s = (raw ?? "").toString().replace(/[^0-9.,]/g, "");
  const i = s.indexOf(".");
  if (i !== -1) s = s.slice(0, i + 1) + s.slice(i + 1).replace(/\./g, "");
  return s;
};

const parserStrict = (v) => sanitizeNumeric(v).replace(/,/g, "");

const formatterWithCommas = (v) => {
  if (v === null || v === undefined || v === "") return "";
  const num = Number(v);
  if (isNaN(num)) return "";
  const s = String(num);
  const [int = "", dec] = s.split(".");
  const intFmt = int.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return dec !== undefined ? `${intFmt}.${dec}` : intFmt;
};

function Form({ name }) {
  const [, startTransition] = useTransition();
  const searchDebounceRef = useRef(null);
  const [activeTab, setActiveTab] = useState(2);
  const [formItemList, setFormItemList] = useState([]);
  const [showInitialStockModal, setShowInitialStockModal] = useState(false);
  const [selectedItemForInitial, setSelectedItemForInitial] = useState(null);
  const shouldSelectFirstRowRef = useRef(true);
  const currentItemIdRef = useRef(null);
  const isManualSelectionRef = useRef(false);
  const [isFormItemHistoryLoaded, setIsFormItemHistoryLoaded] = useState(false);

  const [formItemList2, setFormItemList2] = useState([]);
  const [formItemOnHand, setFormItemOnHand] = useState([]);
  const [formItemHistory, setFormItemHistory] = useState([]);
  const [open, setOpen] = useState(false);
  // ตั้งค่า default เป็นปีและเดือนปัจจุบัน (พ.ศ.)
  const currentYearBE = moment().year() + 543;
  const currentMonth = moment().month() + 1;
  const [year, setYear] = useState(currentYearBE.toString());
  const [month, setMonth] = useState(currentMonth.toString());

  //  เก็บข้อมูลทั้งหมดไว้สำหรับ filter
  const [allItemOnHandData, setAllItemOnHandData] = useState([]);
  const [allItemHistoryData, setAllItemHistoryData] = useState([]);

  const [formItemOnHandCaseTab, setFormItemOnHandCaseTab] = useState([]);
  const [whDataList, setWhDataList] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const [searchItemOnHandCaseTab, setSearchItemOnHandCaseTab] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  
  // Pagination สำหรับสินค้าทั้งหมด (client-side)
  const [currentPageAllItems, setCurrentPageAllItems] = useState(1);
  const [itemsPerPageAllItems, setItemsPerPageAllItems] = useState(50);

  // Search สำหรับ Tab 2 (ประวัติสินค้าเคลื่อนไหว)
  const [searchItemHistory, setSearchItemHistory] = useState("");
  const [filteredItemHistory, setFilteredItemHistory] = useState([]);
  
  // Pagination สำหรับ Tab 1
  const [currentPageTab1, setCurrentPageTab1] = useState(1);
  const [itemsPerPageTab1, setItemsPerPageTab1] = useState(50);
  
  // Pagination สำหรับ Tab 2 (ประวัติสินค้าเคลื่อนไหว)
  const [currentPageTab2, setCurrentPageTab2] = useState(1);
  const [itemsPerPageTab2, setItemsPerPageTab2] = useState(50);
  const [initialQuantity, setInitialQuantity] = useState("");
  const allItemsScrollRef = useRef(null);
  const savedScrollTopRef = useRef(0);
  const restoringScrollRef = useRef(false);
  const pendingScrollItemIdRef = useRef(null);
  const pendingScrollWhIdRef = useRef(null);
  const activeItemSearchRef = useRef({ term: "", option: "3" });
  const skipFilterEffectRef = useRef(false);

  // ข้อมูลตั้งต้น
  const [itemId, setItemId] = useState(null);
  const warehouse_Id = localStorage.getItem("WHID");
  const Emp_Position = localStorage.getItem("EmpPosition");
  const [warehouseId, setWarehouseId] = useState(
    warehouse_Id ? parseCurrency(warehouse_Id, 10) : null
  );

  // สำหรับ Freeze หน้าจอตอนทำรายการ
  const [isLoading, setIsLoading] = useState(false);
  const [searchItemTerm, setSearchItemTerm] = useState("");
  const [filterOption, setFilterOption] = useState("3");

  // Modal
  const [showWhModal, setShowWhModal] = useState(false);
  const handleWhShow = () => setShowWhModal(true);
  const [showItemModal, setShowItemModal] = useState(false);
  const latestSearchRef = useRef(0);
  const rowRefs = useRef([]);
  const itemWH = localStorage?.getItem("stc-item-wh");

  const debounceRef = useRef(null);
  const itemIdRef = useRef(null);
  const skipNextSelectEffectRef = useRef(false);

  const handleWhClose = async () => {
    setShowWhModal(false);

    currentItemIdRef.current = itemId;
    shouldSelectFirstRowRef.current = false;

    savedScrollTopRef.current = allItemsScrollRef.current?.scrollTop || 0;

    await initializeWHOnly(true);
    await handleItemSearchFromDB(searchItemTerm, filterOption, true);

    if (itemId && warehouseId) {
      await onRowSelectOnHand(itemId, warehouseId);
    }
  };

  const onlyNumberKeyDown = (e) => {
    const { key, ctrlKey, metaKey } = e;
    if (ctrlKey || metaKey) return;

    const allowNav = new Set([
      "Backspace",
      "Delete",
      "Tab",
      "Enter",
      "Escape",
      "Home",
      "End",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
    ]);
    if (allowNav.has(key)) return;

    if (/[0-9]/.test(key)) return;
    if (key === ",") return;
    if (key === ".") {
      const el = e.currentTarget;
      const v = el?.value ?? "";
      const hasDot = v.includes(".");
      if (!hasDot) return;
      const dotIdx = v.indexOf(".");
      const { selectionStart, selectionEnd } = el;
      const coversDot =
        typeof selectionStart === "number" &&
        typeof selectionEnd === "number" &&
        selectionStart <= dotIdx &&
        dotIdx < selectionEnd;
      if (!coversDot) e.preventDefault();
      return;
    }
    e.preventDefault();
  };

  const selectOnFocus = (e) => {
    setTimeout(() => e?.target?.select?.(), 0);
  };

  const handleInitialStockShow = (item, index) => {
    isManualSelectionRef.current = true;
    setSelectedIndex(index);
    setSelectedItemForInitial(item);
    setInitialQuantity("");
    
    // ตรวจสอบและ set คลังอัตโนมัติเมื่อเปิด modal (ถ้ายังไม่มี)
    if (!warehouseId && whDataList.length > 0) {
      const localWHID =
        localStorage.getItem("WHID") ||
        localStorage.getItem("whId") ||
        localStorage.getItem("WHId") ||
        localStorage.getItem("stc-item-wh") ||
        "";
      
      if (localWHID) {
        const found = whDataList.find((w) => String(w.WH_Id) === String(localWHID));
        if (found) {
          setWarehouseId(parseCurrency(found.WH_Id, 10));
        }
      }
    }
    
    setShowInitialStockModal(true);
  };

  const handleInitialStockClose = () => {
    setShowInitialStockModal(false);
    setSelectedItemForInitial(null);
  };

  const handleInitialStockSubmit = async ({
    itemId,
    itemCode,
    itemName,
    warehouseId: whId,
    quantity,
  }) => {
    try {
      setIsLoading(true);

      if (!whId) {
        setIsLoading(false);
        return getAlert("FAILED", "กรุณาเลือกคลัง");
      }

      await manageWhItemData(
        itemId,
        itemCode,
        itemName,
        whId,
        "BG",
        quantity,
        null,
        "เริ่มต้นคลัง",
        "เริ่มต้นคลัง",
        null
      );

      //  จำตำแหน่งสกอลล์ก่อนรีเฟรช (สำคัญ)
      savedScrollTopRef.current = allItemsScrollRef.current?.scrollTop || 0;

      // รีเฟรชข้อมูล (ให้คงแถวเดิม)
      currentItemIdRef.current = itemId;
      shouldSelectFirstRowRef.current = false;
      await initializeWHOnly(true);

      if (itemId && whId) {
        await onRowSelectOnHand(itemId, whId);
      }

      getAlert("OK", "ตั้งต้นสินค้าสำเร็จ");
      handleInitialStockClose();
    } catch (error) {
      getAlert("FAILED", error.message || error);
    } finally {
      setIsLoading(false);
    }
  };

  const hasInitialStockInWarehouse = (itemId, warehouseId) => {
    if (!warehouseId || !allItemOnHandData.length) return false;

    const itemInWarehouse = allItemOnHandData.find(
      (item) => item.Item_Id === itemId && item.WH_Id === parseInt(warehouseId)
    );

    // ถ้ามี Last_STC_Date หรือมียอดคงเหลือ แสดงว่าเคยตั้งต้นแล้ว
    return !!itemInWarehouse && itemInWarehouse.Last_STC_Date;
  };

  const handleADJClose = async (updatedItemId, updatedWarehouseId) => {
    setShowWhModal(false);
    
    // ถ้ามี updatedItemId และ updatedWarehouseId ให้รีเฟรชข้อมูลและ scroll
    if (updatedItemId && updatedWarehouseId) {
      // เก็บ itemId ไว้ก่อนรีเฟรช
      currentItemIdRef.current = updatedItemId;
      shouldSelectFirstRowRef.current = false;
      
      // เก็บข้อมูลไว้ใน ref เพื่อให้ useEffect จัดการ
      pendingScrollItemIdRef.current = updatedItemId;
      pendingScrollWhIdRef.current = updatedWarehouseId === "all" ? "all" : parseCurrency(updatedWarehouseId, 10);
      
      // เลือกคลังที่ปรับปรุงใน tab ด้านล่าง
      await onChangeWarehouse(pendingScrollWhIdRef.current);
      
      // รีเฟรชข้อมูลสินค้า (ไม่ให้เลือกแถวแรก)
      await handleItemSearchFromDB(searchItemTerm, filterOption, false);
    } else {
      // ถ้าไม่มีข้อมูล ให้รีเฟรชข้อมูลปกติ
      await handleItemSearchFromDB(searchItemTerm, filterOption, false);
    }
  };

  // useEffect สำหรับจัดการ scroll ไปที่รายการสินค้าที่ปรับปรุง
  useEffect(() => {
    if (pendingScrollItemIdRef.current && pendingScrollWhIdRef.current && formItemList.length > 0) {
      const updatedItemId = pendingScrollItemIdRef.current;
      const whIdToSelect = pendingScrollWhIdRef.current;
      
      // หา index ของรายการสินค้าที่ปรับปรุง
      const itemIndex = formItemList.findIndex(item => item.Item_Id === updatedItemId);
      
      if (itemIndex >= 0) {
        // เลือกรายการสินค้าที่ปรับปรุง
        setSelectedIndex(itemIndex);
        setItemId(updatedItemId);
        currentItemIdRef.current = updatedItemId;
        
        // รีเฟรชประวัติสินค้า
        onRowSelectOnHand(updatedItemId, whIdToSelect);
        
        // Scroll ไปที่รายการสินค้าที่ปรับปรุง (รอให้ DOM อัปเดต)
        setTimeout(() => {
          if (rowRefs.current[itemIndex]) {
            rowRefs.current[itemIndex].scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }, 300);
      } else {
        // ถ้าหาไม่เจอ ให้รีเฟรชประวัติสินค้า
        onRowSelectOnHand(updatedItemId, whIdToSelect);
      }
      
      // ล้าง ref
      pendingScrollItemIdRef.current = null;
      pendingScrollWhIdRef.current = null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formItemList]);

  const buildItemSearchClause = (searchTerm, filterOption) => {
    let query = `AND Item_Status = 'Y' `;
    if (searchTerm) {
      const normalized = searchTerm.trim().replace(/\s+/g, " ");
      query += `AND (
      Item_Code LIKE '%${normalized}%'
      OR Item_Name LIKE '%${normalized}%'
    ) `;
    }

    if (filterOption === "0") query += "AND Item_Onhand > 0 ";
    if (filterOption === "1") query += "AND Item_Onhand >= 0 ";
    if (filterOption === "2") query += "AND Item_Onhand = 0 ";

    return query;
  };

  const fetchAllItemsList = async ({ requestId } = {}) => {
    const searchTerm = activeItemSearchRef.current.term;
    const filterOption = activeItemSearchRef.current.option;
    const baseQuery = buildItemSearchClause(searchTerm, filterOption);
    const orderBy =
      "ORDER BY Item_Short_Name, Item_Brand, Item_Series, Item_Colour, Item_Size, Item_Id";

    const itemList = await getDataWithComp(
      "Tb_Set_Item",
      `${baseQuery} ${orderBy}`,
      {
        fields: [
          "Item_Id",
          "Item_Code",
          "Item_Name",
          "Item_Onhand",
          "Item_Unit_IN",
          "Item_Group",
          "Item_Price",
          "Item_PriceA",
          "Item_PriceB",
        ],
      }
    );

    if (requestId && requestId !== latestSearchRef.current) return;

    const items = itemList || [];
    setFormItemList(items);
    return items;
  };

  // ปรับ initializeWHOnly
  const initializeWHOnly = async (preserveSelection = true) => {
    //  ถ้า preserveSelection = true → ห้ามเลือกแถวแรก
    if (preserveSelection) {
      currentItemIdRef.current = itemId;
      shouldSelectFirstRowRef.current = false;
    }

    await fetchAllItemsList();

    const whList = await getDataWithComp(
      "Tb_Set_WH",
      `AND WH_Status = 'Y' ORDER BY  WH_Name ASC`
    );

    if (whList && whList.length > 0) {
      setWhDataList(whList);
    }

    return formItemList || [];
  };

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      const whDataList = await getDataWithComp(
        "Tb_Set_WH",
        `AND WH_Status = 'Y' ORDER BY  WH_Name ASC`
      );
      if (whDataList && whDataList.length > 0) {
        setWhDataList(whDataList);
      }

      await loadLocalStorageData();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };


  const onChangeWarehouse = async (id) => {
    //  เพิ่มบรรทัดนี้ - ป้องกันไม่ให้เลือกแถวแรก
    shouldSelectFirstRowRef.current = false;
    currentItemIdRef.current = itemId;
    
    // Reset หน้าแรกเมื่อเปลี่ยนคลัง
    setCurrentPageTab1(1);
    
    // Clear ข้อมูลเก่าก่อน query ใหม่
    setFormItemOnHandCaseTab([]);

    // ถ้าเลือก "คลังทั้งหมด" ให้เก็บค่า "all" ไว้ ไม่ parse เป็นตัวเลข
    if (id === "all") {
      setWarehouseId("all");
      // Query ข้อมูลใหม่ทุกครั้งที่เลือก "คลังทั้งหมด"
      try {
        const allOnHand = await getDataWithComp(
          "API_1101_WH_ITEM_ONHAND",
          `ORDER BY Item_Code ASC`
        );
        setFormItemOnHandCaseTab(allOnHand || []);
        // เก็บไว้ใน allItemOnHandData สำหรับใช้งานอื่นๆ
        setAllItemOnHandData(allOnHand || []);
      } catch (error) {
        setFormItemOnHandCaseTab([]);
      }
      // ถ้ามี itemId ให้ filter ประวัติด้วย (Tab 2 เท่านั้น)
      if (itemId) {
        // Filter ประวัติเท่านั้น ไม่ต้อง filter formItemOnHandCaseTab
        if (allItemHistoryData.length > 0) {
          const filteredHistory = allItemHistoryData.filter(
            (item) => item.Item_Id === itemId
          );
          setFormItemHistory(filteredHistory);
        }
      }
    } else {
      const parsedId = parseCurrency(id, 10);
      setWarehouseId(parsedId);
      
      // Query ข้อมูลใหม่ทุกครั้งที่เลือกคลังเฉพาะ
      try {
        const filteredOnHand = await getDataWithComp(
          "API_1101_WH_ITEM_ONHAND",
          `AND WH_Id = ${parsedId} ORDER BY Item_Code ASC`
        );
        setFormItemOnHandCaseTab(filteredOnHand || []);
      } catch (error) {
        setFormItemOnHandCaseTab([]);
      }
      
      // ถ้ามี itemId ให้ filter ประวัติด้วย (Tab 2 เท่านั้น)
      if (itemId && parsedId) {
        // Filter ประวัติเท่านั้น ไม่ต้อง filter formItemOnHandCaseTab
        if (allItemHistoryData.length > 0) {
          const filteredHistory = allItemHistoryData.filter(
            (item) => item.WH_Id === parseInt(parsedId) && item.Item_Id === itemId
          );
          setFormItemHistory(filteredHistory);
        }
      }
    }
  };

  const loadLocalStorageData = async () => {
    const itemSearch = localStorage.getItem("stc-item-search") || "";
    const itemOption = localStorage.getItem("stc-item-option") || "3";

    const itemId = localStorage.getItem("stc-item-id");
    const activeTab = localStorage.getItem("stc-active-tab");
    const selectedWarehouse = localStorage.getItem("stc-select-warehouse");
    const year = localStorage.getItem("stc-year");
    const month = localStorage.getItem("stc-month");

    setSearchItemTerm(itemSearch);
    skipFilterEffectRef.current = true;
    setFilterOption(itemOption);

    // ถ้าไม่มี itemId ใน localStorage (เข้ามาครั้งแรก) ให้เลือกรายการแรก
    const shouldSelectFirst = !itemId;
    
    await handleItemSearchFromDB(itemSearch, itemOption, !shouldSelectFirst);

    if (itemId && itemWH) {
      const parsedItemId = parseCurrency(itemId, 10);
      const parsedItemWH = parseCurrency(itemWH, 10);
      setItemId(parsedItemId);
      await onRowSelectOnHand(parsedItemId, parsedItemWH);
    } else if (shouldSelectFirst) {
      // ถ้าไม่มี itemId ใน localStorage ให้ตั้งค่าให้เลือกรายการแรก
      shouldSelectFirstRowRef.current = true;
      currentItemIdRef.current = null;
    }

    if (activeTab) setActiveTab(parseCurrency(activeTab, 10));
    if (selectedWarehouse) {
      // รองรับ "all" หรือ WH_Id (ตัวเลข)
      if (selectedWarehouse === "all") {
        setWarehouseId("all");
      } else {
        setWarehouseId(parseCurrency(selectedWarehouse, 10));
      }
    }
    // ถ้ามี year/month ใน localStorage ให้ใช้ค่าเหล่านั้น ไม่เช่นนั้นใช้ค่า default (ปีและเดือนปัจจุบัน)
    if (year) {
      setYear(year);
    } else {
      // ถ้าไม่มี year ใน localStorage ให้ใช้ค่า default และบันทึกลง localStorage
      const defaultYear = currentYearBE.toString();
      setYear(defaultYear);
      localStorage.setItem("stc-year", defaultYear);
    }
    if (month) {
      setMonth(month);
    } else {
      // ถ้าไม่มี month ใน localStorage ให้ใช้ค่า default และบันทึกลง localStorage
      const defaultMonth = currentMonth.toString();
      setMonth(defaultMonth);
      localStorage.setItem("stc-month", defaultMonth);
    }
    // ถ้ามี itemId อยู่แล้ว ให้ค้นหาประวัติตามปี/เดือนที่เลือก
    if (itemId) {
      const finalYear = year || currentYearBE.toString();
      const finalMonth = month || currentMonth.toString();
      await handleHistorySearch(finalYear, finalMonth, itemId, selectedWarehouse);
    }
  };

  const onRowSelectOnHand = async (itemId, whId) => {
    try {
      // setItemId(itemId);

      //  Clear ข้อมูลเก่าทันที
      setFormItemOnHand([]);
      setFormItemHistory([]);
      // ล้างการค้นหาใน Tab 2 เมื่อเลือกสินค้าใหม่
      setSearchItemHistory("");
      setFilteredItemHistory([]);
      // ไม่ต้อง clear formItemOnHandCaseTab เพราะอาจจะถูก filter จาก onChangeWarehouse แล้ว

      // ดึงข้อมูลสินค้าคงเหลือของ item นี้ (ทุกคลัง)
      const itemOnHand = await getDataWithComp(
        "API_1101_WH_ITEM_ONHAND",
        `AND Item_Id = ${itemId} ORDER BY WH_Name ASC`
      );

      if (itemOnHand && itemOnHand.length > 0) {
        setFormItemOnHand(itemOnHand);
      }

      //  ดึงข้อมูลประวัติตามปี/เดือนที่เลือก
      // ใช้ warehouseId state ปัจจุบันแทน whId ที่ส่งมา เพื่อให้สอดคล้องกับการเลือกคลัง
      const preferredWhId =
        (whId && whId !== "all" ? whId : null) ||
        (warehouseId && warehouseId !== "all" ? warehouseId : null) ||
        itemOnHand?.[0]?.WH_Id ||
        null;

      const whToUse = preferredWhId || whId || warehouseId || null;

      if (whToUse) {
        if (String(warehouseId) !== String(whToUse)) {
          setWarehouseId(whToUse);
          localStorage.setItem("stc-select-warehouse", String(whToUse));
          localStorage.setItem("WHID", String(whToUse));
        }
        await onChangeWarehouse(whToUse);
      }

      const currentWhId = whToUse;
      await handleHistorySearch(year, month, itemId, currentWhId);

      //  ดึงข้อมูลสินค้าคงคลังทั้งหมด (เก็บไว้สำหรับ filter)
      const allOnHand = await getDataWithComp(
        "API_1101_WH_ITEM_ONHAND",
        `ORDER BY Item_Code ASC`
      );
      setAllItemOnHandData(allOnHand || []);
      
      // ไม่ต้อง set formItemOnHandCaseTab เพราะ onChangeWarehouse จะดูแลเอง
      // ถ้ายังไม่มีการเลือกคลัง หรือยังไม่มี warehouseId state ให้ filter ตาม whId
      if (!warehouseId && whId && allOnHand && allOnHand.length > 0) {
        if (whId === "all") {
          setFormItemOnHandCaseTab(allOnHand || []);
        } else {
          const filteredOnHand = (allOnHand || []).filter(
            (item) => item.WH_Id === parseInt(whId)
          );
          setFormItemOnHandCaseTab(filteredOnHand);
        }
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  // SET ITEM
  const handleItemShow = async () => {
    const itemList = await getDataWithComp(
      "Tb_Set_Item",
      `AND Item_Status = 'Y'  ORDER BY Item_Short_Name, Item_Brand, Item_Series, Item_Colour, Item_Size`
    );

    const itemHistory = await getDataWithComp(
      "API_1201_WH_ITEM_STC",
      `AND WH_Id = ${warehouseId} ORDER BY STC_SEQ DESC`
    );

    const itemHistoryIds = new Set(itemHistory.map((h) => h.Item_Id));

    const filteredItems = itemList.filter(
      (item) => !itemHistoryIds.has(item.Item_Id)
    );

    setFormItemList2(filteredItems);
    setShowItemModal(true);
  };

  const handleItemClose = () => setShowItemModal(false);
  const handleBeginWarehouse = async (itemsSelected) => {
    try {
      setShowItemModal(false);
      setIsLoading(true);

      if (warehouseId === null) {
        setIsLoading(false);
        return getAlert("FAILED", "กรุณาเลือกคลัง");
      }

      const uniqueItems = Array.from(
        new Set(itemsSelected.map((item) => item.Item_Id))
      ).map((id) => itemsSelected.find((item) => item.Item_Id === id));

      await Promise.all(
        uniqueItems.map((item) =>
          manageWhItemData(
            item.Item_Id,
            item.Item_Code,
            item.Item_Name,
            parseCurrency(warehouseId),
            "BG",
            parseCurrency(item.inputQty || 0, 10),
            null,
            "เริ่มต้นคลัง",
            "เริ่มต้นคลัง",
            null
          )
        )
      );

      //  เก็บ index และ itemId ปัจจุบันไว้ก่อน
      const currentSelectedIndex = selectedIndex;
      const currentSelectedItemId = formItemList[selectedIndex]?.Item_Id;

      const itemList = await fetchAllItemsList();

      const whList = await getDataWithComp(
        "Tb_Set_WH",
        `AND WH_Status = 'Y' ORDER BY  WH_Name ASC`
      );
      if (whList && whList.length > 0) {
        setWhDataList(whList);
      }

      if (itemList && itemList.length > 0) {
        isManualSelectionRef.current = true;
        shouldSelectFirstRowRef.current = false;
        currentItemIdRef.current = currentSelectedItemId;

        if (currentSelectedItemId) {
          const foundIndex = itemList.findIndex(
            (f) => f.Item_Id === currentSelectedItemId
          );

          if (foundIndex !== -1) {
            // เจอแถวเดิม -> กลับไปแถวเดิม
            currentItemIdRef.current = currentSelectedItemId;
            skipNextSelectEffectRef.current = true;
            setSelectedIndex(foundIndex);
            setItemId(currentSelectedItemId);
            localStorage.setItem("stc-item-id", currentSelectedItemId);
            localStorage.setItem("stc-item-wh", warehouseId);
            await onRowSelectOnHand(currentSelectedItemId, warehouseId);
          } else {
            // ไม่เจอแถวเดิม -> ไปแถวที่ใกล้ที่สุด
            const safeIndex = Math.min(
              currentSelectedIndex,
              itemList.length - 1
            );
            const newItem = itemList[safeIndex];
            currentItemIdRef.current = newItem.Item_Id;
            skipNextSelectEffectRef.current = true;
            setSelectedIndex(safeIndex);
            setItemId(newItem.Item_Id);

            localStorage.setItem("stc-item-id", newItem.Item_Id);
            localStorage.setItem("stc-item-wh", warehouseId);
            await onRowSelectOnHand(newItem.Item_Id, warehouseId);
          }
        }
        setTimeout(() => {
          isManualSelectionRef.current = false;
        }, 0);
      }

      getAlert("OK", "เริ่มต้นคลังสินค้าสำเร็จ");
      await handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    } finally {
      setIsLoading(false);
    }
  };


  const handleItemSearchFromDB = async (
    searchTerm,
    filterOption,
    preserve = true
  ) => {
    const reqId = ++latestSearchRef.current;

    activeItemSearchRef.current = {
      term: searchTerm || "",
      option: filterOption || "3",
    };

    if (preserve && itemId) {
      currentItemIdRef.current = itemId;
      shouldSelectFirstRowRef.current = false;
    }
    shouldSelectFirstRowRef.current = !preserve;
    if (!preserve) {
      setCurrentPageAllItems(1);
    }

    // ถ้ามี newlyCreatedItemIdRef อยู่ แสดงว่ากำลังจะ active รายการใหม่
    // ไม่ต้อง preserve selection
    if (newlyCreatedItemIdRef.current) {
      shouldSelectFirstRowRef.current = false;
    }

    await fetchAllItemsList({ requestId: reqId });
  };

  const triggerSearchAndActivateFirst = async (term) => {
    if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);

    // เตรียมให้ auto-select รายการแรกหลังค้นหา
    shouldSelectFirstRowRef.current = true;
    currentItemIdRef.current = null;
    setSelectedIndex(-1);
    setItemId(null);

    await handleItemSearchFromDB(term, filterOption, false);
  };

  const handleHistorySearch = async (year, month, itemId, warehouseId) => {
    let query = `AND Item_Id = ${itemId} `;
    
    // ถ้าเลือก "คลังทั้งหมด" ไม่ต้อง filter WH_Id
    if (warehouseId && warehouseId !== "all") {
      query += `AND WH_Id = ${warehouseId} `;
    }

    let yearInAD = "";
    if (year) {
      yearInAD = (parseCurrency(year) - 543).toString();
    }

    if (yearInAD) {
      query += `AND YEAR(STC_Date) = ${yearInAD} `;
    }

    if (month) {
      query += `AND MONTH(STC_Date) = ${parseCurrency(month)} `;
    }

    query += `ORDER BY STC_SEQ DESC`;

    const itemHistory = await getDataWithComp("API_1201_WH_ITEM_STC", query);

    if (itemHistory && itemHistory.length > 0) {
      setFormItemHistory(itemHistory);
      // Initialize filteredItemHistory ด้วยข้อมูลทั้งหมด (ถ้ายังไม่มี search term)
      if (!searchItemHistory) {
        setFilteredItemHistory(itemHistory);
      } else {
        // ถ้ามี search term อยู่แล้ว ให้ filter ตาม search term
        const keyword = searchItemHistory.trim().replace(/\s+/g, " ").toLowerCase();
        const filtered = itemHistory.filter((item) => {
          const docNo = item.Doc_No?.trim().replace(/\s+/g, " ").toLowerCase() || "";
          const docNoRef = item.Doc_NoRef?.trim().replace(/\s+/g, " ").toLowerCase() || "";
          const stcRemark = item.STC_Remark?.trim().replace(/\s+/g, " ").toLowerCase() || "";
          
          return (
            docNo.includes(keyword) ||
            docNoRef.includes(keyword) ||
            stcRemark.includes(keyword)
          );
        });
        setFilteredItemHistory(filtered);
      }
    } else {
      setFormItemHistory([]);
      setFilteredItemHistory([]);
    }
  };

  // ฟังก์ชันจัดการการเปลี่ยนปี
  const handleYearChange = async (selectedYear) => {
    setYear(selectedYear);
    localStorage.setItem("stc-year", selectedYear);
    // ถ้ามี itemId อยู่แล้ว ให้ค้นหาประวัติใหม่
    if (itemId) {
      await handleHistorySearch(selectedYear, month, itemId, warehouseId);
    }
  };

  // ฟังก์ชันจัดการการเปลี่ยนเดือน
  const handleMonthChange = async (selectedMonth) => {
    setMonth(selectedMonth);
    localStorage.setItem("stc-month", selectedMonth);
    // ถ้ามี itemId อยู่แล้ว ให้ค้นหาประวัติใหม่
    if (itemId) {
      await handleHistorySearch(year, selectedMonth, itemId, warehouseId);
    }
  };

  // สร้างรายการปี (พ.ศ.) สำหรับ dropdown (5 ปีย้อนหลัง ถึง 5 ปีข้างหน้า)
  const generateYearOptions = () => {
    const currentYearBE = moment().year() + 543;
    const years = [];
    for (let i = currentYearBE - 5; i <= currentYearBE + 5; i++) {
      years.push(i);
    }
    return years;
  };

  // สร้างรายการเดือนสำหรับ dropdown
  const generateMonthOptions = () => {
    const months = [
      { value: "1", label: "มกราคม" },
      { value: "2", label: "กุมภาพันธ์" },
      { value: "3", label: "มีนาคม" },
      { value: "4", label: "เมษายน" },
      { value: "5", label: "พฤษภาคม" },
      { value: "6", label: "มิถุนายน" },
      { value: "7", label: "กรกฎาคม" },
      { value: "8", label: "สิงหาคม" },
      { value: "9", label: "กันยายน" },
      { value: "10", label: "ตุลาคม" },
      { value: "11", label: "พฤศจิกายน" },
      { value: "12", label: "ธันวาคม" },
    ];
    return months;
  };

  const handleSubmit = async (payload) => {
    setIsLoading(true);
    const data = await submitItems(payload);
    if (data.ok) {
      setOpen(false);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const newlyCreatedItemIdRef = useRef(null);
  const newlyCreatedWhIdRef = useRef(null);

  const handleDataChanged = async (response) => {
    // Active รายการที่เพิ่งสร้าง (ใช้ Item_Id แรกที่สร้างได้)
    if (response?.ids && Object.keys(response.ids).length > 0) {
      const firstItemId = Object.values(response.ids)[0];
      
      // ใช้คลังที่เพิ่มสินค้าใน ProductModal (whIds จาก response)
      const whIds = response?.whIds || [];
      const firstWhId = whIds.length > 0 ? whIds[0] : null;
      
      if (firstItemId && firstWhId) {
        // เก็บ Item_Id และ WH_Id ไว้ใน ref เพื่อให้ useEffect ใช้
        newlyCreatedItemIdRef.current = firstItemId;
        newlyCreatedWhIdRef.current = parseInt(firstWhId);
        
        // ตั้งค่า ref เพื่อให้ useEffect จัดการ active
        currentItemIdRef.current = firstItemId;
        shouldSelectFirstRowRef.current = false;
        
        // Active คลังที่เพิ่มสินค้า
        await onChangeWarehouse(firstWhId);
        
        // เก็บไว้ใน localStorage
        localStorage.setItem("stc-select-warehouse", String(firstWhId));
        localStorage.setItem("WHID", String(firstWhId));
      } else if (firstItemId && warehouse_Id) {
        // Fallback: ใช้ warehouse_Id จาก localStorage ถ้าไม่มี whIds ใน response
        newlyCreatedItemIdRef.current = firstItemId;
        newlyCreatedWhIdRef.current = parseInt(warehouse_Id);
        currentItemIdRef.current = firstItemId;
        shouldSelectFirstRowRef.current = false;
      }
    }
    
    // Fetch ข้อมูลใหม่หลังจากบันทึกสำเร็จ (ไม่ preserve selection เพื่อให้เลือกรายการใหม่)
    await handleItemSearchFromDB(searchItemTerm, filterOption, false);
    
    // useEffect จะจัดการ active รายการหลังจาก formItemList อัปเดต
  };

  // useEffect สำหรับ active รายการที่เพิ่งสร้างหลังจาก formItemList อัปเดต
  // ต้องทำงานก่อน useEffect ที่ auto-select รายการแรก
  useEffect(() => {
    if (
      newlyCreatedItemIdRef.current &&
      newlyCreatedWhIdRef.current &&
      formItemList.length > 0
    ) {
      const itemId = newlyCreatedItemIdRef.current;
      const whId = newlyCreatedWhIdRef.current;
      
      // หา index ของรายการที่เพิ่งสร้าง
      const itemIndex = formItemList.findIndex(
        (item) => item.Item_Id === itemId
      );
      
      if (itemIndex !== -1) {
        // ตั้ง flag เพื่อป้องกัน useEffect อื่นๆ ทับการเลือก (ต้องตั้งก่อน setState)
        isManualSelectionRef.current = true;
        shouldSelectFirstRowRef.current = false;
        
        // Active รายการที่เพิ่งสร้าง
        setSelectedIndex(itemIndex);
        setItemId(itemId);
        currentItemIdRef.current = itemId;
        
        // เรียก onRowSelectOnHand เพื่อแสดงรายละเอียด
        onRowSelectOnHand(itemId, whId);
        
        // เซ็ต itemId ใน localStorage เพื่อให้จำไว้
        localStorage.setItem("stc-item-id", String(itemId));
        localStorage.setItem("stc-item-wh", String(whId));
        
        // Scroll ไปที่รายการที่เลือก (รอให้ DOM อัปเดต)
        setTimeout(() => {
          if (rowRefs.current[itemIndex]) {
            rowRefs.current[itemIndex].scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }, 150);
        
        // Reset ref หลังจากใช้งานเสร็จ (รอให้ useEffect อื่นๆ ทำงานเสร็จ)
        setTimeout(() => {
          newlyCreatedItemIdRef.current = null;
          newlyCreatedWhIdRef.current = null;
          
          // Reset flag หลังจากทำงานเสร็จ
          setTimeout(() => {
            isManualSelectionRef.current = false;
          }, 100);
        }, 300);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formItemList, warehouseId]);

  useEffect(() => {
    if (skipFilterEffectRef.current) {
      skipFilterEffectRef.current = false;
      return;
    }
    handleItemSearchFromDB(searchItemTerm, filterOption, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterOption]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (formItemList.length === 0) return;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        //  เพิ่มบรรทัดนี้
        isManualSelectionRef.current = true;
        setSelectedIndex((prev) =>
          prev < formItemList.length - 1 ? prev + 1 : prev
        );
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        //  เพิ่มบรรทัดนี้
        isManualSelectionRef.current = true;
        setSelectedIndex((prev) => (prev > 0 ? prev - 1 : prev));
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [formItemList]);

  useEffect(() => {
    if (restoringScrollRef.current) return;
    if (selectedIndex >= 0 && rowRefs.current[selectedIndex]) {
      rowRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  useEffect(() => {
    itemIdRef.current = itemId;
  }, [itemId]);

  useEffect(() => {
    if (selectedIndex >= 0 && selectedIndex < formItemList.length) {
      const selectedItem = formItemList[selectedIndex];
      if (skipNextSelectEffectRef.current) {
        skipNextSelectEffectRef.current = false;
        return;
      }

      //  ล้าง debounce เก่า
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }

      //  ตั้ง debounce ใหม่
      debounceRef.current = setTimeout(() => {
        const nextId = selectedItem.Item_Id;
        if (
          currentItemIdRef.current === nextId &&
          itemIdRef.current === nextId
        ) {
          isManualSelectionRef.current = false;
          return;
        }
        currentItemIdRef.current = selectedItem.Item_Id;
        setItemId(selectedItem.Item_Id);
        onRowSelectOnHand(selectedItem.Item_Id, warehouseId);
        localStorage.setItem("stc-item-id", selectedItem.Item_Id);
        localStorage.setItem("stc-item-wh", warehouseId);

        //  Reset flag หลังจากทำงานเสร็จ
        isManualSelectionRef.current = false;
      }, 100);

      return () => {
        if (debounceRef.current) {
          clearTimeout(debounceRef.current);
        }
      };
    }
  }, [selectedIndex, warehouseId]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsFormItemHistoryLoaded(!formItemHistory[0]);
    }, 300);

    return () => clearTimeout(timeout);
  }, [formItemHistory]);

  // Filter ข้อมูลใน Tab 2 ตาม search term (ค้นหาจาก Doc_No, Doc_NoRef, STC_Remark)
  useEffect(() => {
    const keyword = searchItemHistory
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();

    // Reset หน้าเป็น 1 เมื่อมีการค้นหาหรือเปลี่ยนข้อมูล
    setCurrentPageTab2(1);

    if (!keyword) {
      // ถ้าไม่มี keyword ให้แสดงข้อมูลทั้งหมด
      setFilteredItemHistory(formItemHistory);
      return;
    }

    // Filter ตาม Doc_No, Doc_NoRef, STC_Remark
    const filtered = formItemHistory.filter((item) => {
      const docNo = item.Doc_No?.trim().replace(/\s+/g, " ").toLowerCase() || "";
      const docNoRef = item.Doc_NoRef?.trim().replace(/\s+/g, " ").toLowerCase() || "";
      const stcRemark = item.STC_Remark?.trim().replace(/\s+/g, " ").toLowerCase() || "";
      
      return (
        docNo.includes(keyword) ||
        docNoRef.includes(keyword) ||
        stcRemark.includes(keyword)
      );
    });

    setFilteredItemHistory(filtered);
  }, [searchItemHistory, formItemHistory]);

  // Filter ข้อมูลใน Tab 1 ตาม search term เท่านั้น (formItemOnHandCaseTab ถูก filter ตามคลังแล้วจาก onChangeWarehouse)
  useEffect(() => {
    const keyword = searchItemOnHandCaseTab
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();

    // ใช้ formItemOnHandCaseTab เป็นฐานข้อมูล (ถูก filter ตามคลังแล้วจาก onChangeWarehouse)
    // ไม่ต้อง filter ตาม warehouseId อีก เพราะ formItemOnHandCaseTab ถูก filter แล้ว
    const filtered = formItemOnHandCaseTab.filter((item) => {
      const itemCode =
        item.Item_Code?.trim().replace(/\s+/g, " ").toLowerCase() || "";
      const itemName =
        item.Item_Name?.trim().replace(/\s+/g, " ").toLowerCase() || "";
      return itemCode.includes(keyword) || itemName.includes(keyword);
    });

    setFilteredItems(filtered);
    // Reset หน้าแรกเมื่อ filter เปลี่ยน
    setCurrentPageTab1(1);
  }, [searchItemOnHandCaseTab, formItemOnHandCaseTab]);

  // คำนวณ paginated data สำหรับ Tab 1
  const paginatedItems = useMemo(() => {
    const startIndex = (currentPageTab1 - 1) * itemsPerPageTab1;
    const endIndex = startIndex + itemsPerPageTab1;
    return filteredItems.slice(startIndex, endIndex);
  }, [filteredItems, currentPageTab1, itemsPerPageTab1]);

  const paginatedAllItems = useMemo(() => {
    const startIndex = (currentPageAllItems - 1) * itemsPerPageAllItems;
    const endIndex = startIndex + itemsPerPageAllItems;
    return formItemList.slice(startIndex, endIndex);
  }, [formItemList, currentPageAllItems, itemsPerPageAllItems]);

  // Pagination สำหรับ Tab 2 (ประวัติสินค้าเคลื่อนไหว)
  const paginatedItemHistory = useMemo(() => {
    const startIndex = (currentPageTab2 - 1) * itemsPerPageTab2;
    const endIndex = startIndex + itemsPerPageTab2;
    return filteredItemHistory.slice(startIndex, endIndex);
  }, [filteredItemHistory, currentPageTab2, itemsPerPageTab2]);

  useEffect(() => {
    rowRefs.current = [];
  }, [formItemList]);

  useEffect(() => {
    // ถ้ามี newlyCreatedItemIdRef แสดงว่ากำลังจะ active รายการใหม่ → skip
    // ใช้ setTimeout เพื่อให้ useEffect ที่ active รายการใหม่ทำงานก่อน
    const timeoutId = setTimeout(() => {
      if (newlyCreatedItemIdRef.current) {
        return;
      }
      
      if (isManualSelectionRef.current) {
        return;
      }

      if (formItemList.length === 0) return;

      if (!shouldSelectFirstRowRef.current) {
        // ถ้าห้ามเลือกแถวแรก → พยายามคงแถวเดิม
        if (currentItemIdRef.current) {
          const index = formItemList.findIndex(
            (item) => item.Item_Id === currentItemIdRef.current
          );
          if (index !== -1) {
            if (selectedIndex !== index) {
              setSelectedIndex(index);
            }

            shouldSelectFirstRowRef.current = true;
            return;
          }
        }
        shouldSelectFirstRowRef.current = true;
      }

      // เลือกรายการแรกเมื่อเข้ามาครั้งแรก (ไม่มี itemId ที่เลือกอยู่)
      if (selectedIndex === -1 && !currentItemIdRef.current && shouldSelectFirstRowRef.current) {
        const firstItem = formItemList[0];
        if (firstItem) {
          setSelectedIndex(0);
          setItemId(firstItem.Item_Id);
          currentItemIdRef.current = firstItem.Item_Id;
          
          // ถ้ามี warehouseId ให้เรียก onRowSelectOnHand ทันที
          if (warehouseId) {
            onRowSelectOnHand(firstItem.Item_Id, warehouseId);
            localStorage.setItem("stc-item-id", firstItem.Item_Id);
            localStorage.setItem("stc-item-wh", warehouseId);
          } else {
            // ถ้ายังไม่มี warehouseId ให้เก็บ itemId ไว้ก่อน
            localStorage.setItem("stc-item-id", firstItem.Item_Id);
          }
        }
      }
    }, 100); // รอ 100ms เพื่อให้ useEffect ที่ active รายการใหม่ทำงานก่อน
    
    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formItemList, warehouseId]);

  useEffect(() => {
    const el = allItemsScrollRef.current;
    if (!el) return;

    // กันชน: ระหว่างคืนสกอลล์ อย่าให้ scrollIntoView มาดึงไปแถว
    restoringScrollRef.current = true;

    requestAnimationFrame(() => {
      el.scrollTop = savedScrollTopRef.current || 0;

      // ปล่อยกันชนหลังคืนค่าเสร็จ
      requestAnimationFrame(() => {
        restoringScrollRef.current = false;
      });
    });
  }, [formItemList]);

  return (
    <>
      <Breadcrumbs
        page={"คลังสินค้า"}
        items={[
          { name: "คลังสินค้า", url: "/warehouse" },
          { name: name, url: "/warehouse" },
          { name: "สร้าง" + name, url: "#" },
        ]}
      />

      {/* Loading Spinner */}
      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <div style={{ maxHeight: "90vh", overflowY: "auto" }}>
        <div className="container-fluid my-2">
          <div className="row">
            <div className="col-4">
              <div className="d-flex align-items-center">
                <h5 className="text-nowrap card-title mb-0 me-3">
                  ค้นหาสินค้า
                </h5>
                <div className="position-relative w-100">
                  <input
                    type="text"
                    className="form-control pe-5"
                    value={searchItemTerm}
                    onChange={(e) => {
                      const v = e.target.value;
                      setSearchItemTerm(v);
                      localStorage.setItem("stc-item-search", v);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        const v = e.currentTarget.value;
                        triggerSearchAndActivateFirst(v);
                      }
                    }}
                  />

                  {searchItemTerm?.trim() && (
                    <button
                      type="button"
                      className="btn btn-sm btn-light position-absolute top-50 end-0 translate-middle-y me-2"
                      style={{ borderRadius: 999 }}
                      onClick={() => {
                        // เคลียร์ค่า + เคลียร์ debounce ที่ค้าง
                        if (searchDebounceRef.current)
                          clearTimeout(searchDebounceRef.current);

                        setSearchItemTerm("");
                        localStorage.setItem("stc-item-search", "");

                        // รีเฟรชข้อมูลจาก database
                        triggerSearchAndActivateFirst("");
                      }}
                      aria-label="clear search"
                      title="ล้างคำค้นหา"
                    >
                      ✕
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="col-8">
              <div className="d-flex">
                <select
                  className="form-select"
                  style={{ maxWidth: "190px" }}
                  value={filterOption}
                  onChange={(e) => {
                    setFilterOption(e.target.value);
                    localStorage.setItem("stc-item-option", e.target.value);
                  }}
                >
                  <option value="0">แสดงยอดคงเหลือ &#62; 0</option>
                  <option value="1">แสดงยอดคงเหลือ &#62; = 0</option>
                  <option value="2">แสดงยอดคงเหลือ = 0</option>
                  <option value="3">แสดงทุกรายการ</option>
                </select>
                <button
                  type="button"
                  className="btn btn-primary mx-2"
                  onClick={() =>
                    triggerSearchAndActivateFirst(searchItemTerm)
                  }
                  style={{ minWidth: "80px" }}
                >
                  <i className="fa fa-search me-1" aria-hidden="true"></i>
                  ค้นหา
                </button>
                <button
                  className="btn text-white mx-4"
                  style={{ backgroundColor: "#E13F57" }}
                  onClick={() => ExportInventories(formItemOnHand)}
                >
                  <i className="fa fa-file-excel me-1" aria-hidden="true"></i>{" "}
                  Export สินค้ายอดคงเหลือ
                </button>
                <button
                  className="btn text-white"
                  style={{ backgroundColor: "#E13F57" }}
                  onClick={() =>
                    ExportInventoriesWarehouse(formItemOnHandCaseTab)
                  }
                >
                  <i className="fa fa-warehouse me-1" aria-hidden="true"></i>{" "}
                  Export สินค้าแยกตามคลัง
                </button>
              </div>
            </div>
            <div className="col-2" />
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-8">
            <div className="col-12">
              <div className="card">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1px auto auto",
                    alignItems: "self-end",
                    justifyContent: "space-between",
                  }}
                >
                  <div></div>
                  <div>
                    <h5 className="card-title mt-3 me-4 text-center">
                      สินค้าทั้งหมด
                    </h5>
                  </div>
                  <div>
                    <Button
                      type="primary"
                      onClick={() => setOpen(true)}
                      style={{
                        marginRight: 10,
                        backgroundColor: "#E13F57",
                      }}
                    >
                      สร้าง รายการสินค้า
                    </Button>
                    <ProductModal
                      open={open}
                      setOpen={setOpen}
                      onClose={() => setOpen(false)}
                      onSubmit={handleSubmit}
                      onDataChanged={handleDataChanged}
                      mode="create"
                      initialData={null}
                    />
                  </div>
                </div>

                <div className="card-body">
                  <div
                    ref={allItemsScrollRef}
                    className="table-responsive"
                    style={{
                      maxHeight: "350px",
                      overflowY: "auto",
                      marginTop: "5px",
                    }}
                  >
                    <table
                      id="tbl-all-items"
                      className="table table-striped table-hover"
                    >
                      <thead className="thead-dark">
                        <tr>
                          <th className="text-center" style={{ width: "1%" }}>
                            #
                          </th>
                          <th
                            className="text-center"
                            style={{ maxwidth: "100px" }}
                          >
                            รหัสสินค้า
                          </th>
                          <th className="text-center" style={{ width: "38%" }}>
                            ชื่อสินค้า
                          </th>
                          <th className="text-center" style={{ width: "8%" }}>
                            คงเหลือ
                          </th>
                          <th className="text-center" style={{ width: "5%" }}>
                            หน่วย
                          </th>
                          <th className="text-center" style={{ width: "5%" }}>
                            ตั้งต้น
                          </th>
                          <th className="text-center">กลุ่มสินค้า</th>
                          <th className="text-center">ราคา1</th>
                          <th className="text-center">ราคา2</th>
                          <th className="text-center">ราคา3</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedAllItems.length > 0 ? (
                          paginatedAllItems.map((item, index) => {
                            const globalIndex =
                              (currentPageAllItems - 1) *
                                itemsPerPageAllItems +
                              index;
                            return (
                            <tr
                              key={item.Item_Id}
                              ref={(el) => (rowRefs.current[globalIndex] = el)}
                              onClick={() => {
                                isManualSelectionRef.current = true;
                                currentItemIdRef.current = item.Item_Id;
                                setSelectedIndex(globalIndex);
                              }}
                              style={{
                                cursor: "pointer",
                                backgroundColor:
                                  selectedIndex === globalIndex
                                    ? "rgb(105, 188, 216)"
                                    : "transparent",
                                transition: "background-color 0.3s ease",
                              }}
                            >
                              <td className="text-center">{globalIndex + 1}</td>
                              <td
                                className="text-center"
                                style={{ maxwidth: "100px" }}
                              >
                                {item.Item_Code}
                              </td>
                              <td className="text-left">{item.Item_Name}</td>
                              <td className="text-end">
                                {formatCurrency(item.Item_Onhand)}
                              </td>
                              <td className="text-center">
                                {item.Item_Unit_IN}
                              </td>
                              <td className="text-center">
                                {!hasInitialStockInWarehouse(
                                  item.Item_Id,
                                  warehouseId
                                ) ? (
                                  <button
                                    className="btn btn-sm btn-warning"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleInitialStockShow(item, globalIndex);
                                    }}
                                    title="ตั้งต้นสินค้า"
                                  >
                                    <i
                                      className="fa fa-plus-circle"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                ) : (
                                  // <span className="text-success">
                                  //   <i
                                  //     className="fa fa-check-circle"
                                  //     aria-hidden="true"
                                  //   ></i>
                                  // </span>
                                  <></>
                                )}
                              </td>

                              <td className="">{item.Item_Group}</td>
                              <td className="text-end">
                                {formatCurrency(item.Item_Price)}
                              </td>
                              <td className="text-end">
                                {formatCurrency(item.Item_PriceA)}
                              </td>
                              <td className="text-end">
                                {formatCurrency(item.Item_PriceB)}
                              </td>
                            </tr>
                          )})
                        ) : (
                          <tr>
                            <td colSpan={7}>
                              <center>
                                <h5>ไม่พบข้อมูล</h5>
                              </center>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {formItemList.length > 0 && (
                    <div className="mt-3">
                      <Pagination
                        totalItems={formItemList.length}
                        itemsPerPage={itemsPerPageAllItems}
                        currentPage={currentPageAllItems}
                        onPageChange={(page) => {
                          setCurrentPageAllItems(page);
                          setSelectedIndex(-1);
                          setItemId(null);
                          currentItemIdRef.current = null;
                          shouldSelectFirstRowRef.current = true;
                        }}
                        onItemsPerPageChange={(val) => {
                          setItemsPerPageAllItems(val);
                          setCurrentPageAllItems(1);
                          setSelectedIndex(-1);
                          setItemId(null);
                          currentItemIdRef.current = null;
                          shouldSelectFirstRowRef.current = true;
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-4">
            <div className="col-12">
              <div className="card">
                {/* <h5 className="card-title mt-3 me-4 text-center">
                  สินค้าแยกตามคลัง
                </h5> */}
                <div className="card-body">
                  <div className="table-responsive">
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        margin: "0px 0px",
                      }}
                    >
                      {formItemOnHand?.at(0)?.Item_Code
                        ? `${formItemOnHand?.at(0)?.Item_Code}`
                        : ""}
                    </p>
                    <p
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        margin: "-4px 0px",
                      }}
                    >
                      {formItemOnHand?.at(0)?.Item_Name
                        ? `${formItemOnHand?.at(0)?.Item_Name}`
                        : ""}
                    </p>
                    <table
                      id="tbl-onhand"
                      className="table table-striped table-hover"
                    >
                      <thead className="thead-dark">
                        <tr>
                          <th className="text-center" style={{ width: "3%" }}>
                            #
                          </th>
                          {/* <th className="text-center" style={{ width: "15%" }}>
                            รหัสสินค้า
                          </th>
                          <th className="text-center" style={{ width: "30%" }}>
                            ชื่อสินค้า
                          </th> */}
                          <th className="text-center" style={{ width: "25%" }}>
                            คลังสินค้า
                          </th>
                          <th className="text-center" style={{ width: "10%" }}>
                            คงเหลือ
                          </th>

                          <th className="text-center" style={{ width: "20%" }}>
                            วันที่ล่าสุด
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {formItemOnHand.length > 0 ? (
                          formItemOnHand.map((item, index) => (
                            <tr key={item.Item_Id || index + 1}>
                              <td className="text-center">{index + 1}</td>
                              {/* <td className="text-center">{item.Item_Code}</td>
                              <td className="text-left">{item.Item_Name}</td> */}
                              <td className="text-center">{item.WH_Name}</td>

                              <td className="text-end">
                                {formatCurrency(item.Item_Onhand)}
                              </td>
                              <td className="text-center">
                                {item.Last_STC_Date
                                  ? formatDateAndTime(item.Last_STC_Date)
                                  : ""}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={6}>
                              <center>
                                <h5>ไม่พบข้อมูล</h5>
                              </center>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  จำนวน: {formItemOnHand.length.toLocaleString()} รายการ
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row mt-2">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <button
                      style={{ cursor: "pointer", color: "#E13F57" }}
                      className={`nav-link ${activeTab === 1 ? "active" : ""}`}
                      onClick={() => {
                        setActiveTab(1);
                        localStorage.setItem("stc-active-tab", 1);
                      }}
                    >
                      สินค้าแยกตามคลัง
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      style={{ cursor: "pointer", color: "#E13F57" }}
                      className={`nav-link ${activeTab === 2 ? "active" : ""}`}
                      onClick={() => {
                        setActiveTab(2);
                        localStorage.setItem("stc-active-tab", 2);
                      }}
                    >
                      ประวัติสินค้าเคลื่อนไหว
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content mt-3">
                <div
                  className={`tab-pane fade ${
                    activeTab === 1 ? "show active" : ""
                  }`}
                  role="tabpanel"
                >
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <div className=" d-flex">
                          <h4 className="card-title mb-0 me-2" style={{ whiteSpace: "nowrap" }}>เลือกคลัง</h4>
                          <select
                            style={{ width: "200px", whiteSpace: "nowrap" }}
                            className="form-select"
                            value={warehouseId || ""}
                            onChange={(e) => {
                              onChangeWarehouse(e.target.value);
                              localStorage.setItem(
                                "stc-select-warehouse",
                                e.target.value
                              );
                            }}
                          >
                            <option value={""}>กรุณาเลือกคลัง</option>
                            <option value={"all"}>คลังทั้งหมด</option>
                            {whDataList.map((ware) => (
                              <option key={ware.WH_Id} value={ware.WH_Id}>
                                {ware.WH_Name}
                              </option>
                            ))}
                          </select>

                          <h4 className="card-title mb-0 me-2 ms-3" style={{ whiteSpace: "nowrap" }}>เลือกปี</h4>
                          <select
                            style={{ width: "150px", whiteSpace: "nowrap" }}
                            className="form-select"
                            value={year || ""}
                            onChange={(e) => handleYearChange(e.target.value)}
                          >
                            {generateYearOptions().map((y) => (
                              <option key={y} value={y.toString()}>
                                {y}
                              </option>
                            ))}
                          </select>

                          <h4 className="card-title mb-0 me-2 ms-3" style={{ whiteSpace: "nowrap" }}>เลือกเดือน</h4>
                          <select
                            style={{ width: "180px", whiteSpace: "nowrap" }}
                            className="form-select"
                            value={month || ""}
                            onChange={(e) => handleMonthChange(e.target.value)}
                          >
                            {generateMonthOptions().map((m) => (
                              <option key={m.value} value={m.value}>
                                {m.label}
                              </option>
                            ))}
                          </select>

                          <div
                            className="d-flex align-items-center"
                            style={{ marginLeft: "10px" }}
                          >
                            <h5 className="text-nowrap card-title mb-0 me-3">
                              ค้นหาสินค้า
                            </h5>
                            <input
                              type="text"
                              className="form-control"
                              style={{ width: "400px" }}
                              value={searchItemOnHandCaseTab}
                              onChange={(e) => {
                                setSearchItemOnHandCaseTab(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table
                            id="tbl-history"
                            className="table table-striped table-hover"
                          >
                            <thead className="thead-dark">
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "3%" }}
                                >
                                  #
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  รหัสสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "60%" }}
                                >
                                  ชื่อสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "6%" }}
                                >
                                  คงเหลือ
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "12%" }}
                                >
                                  คลังสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "12%" }}
                                >
                                  วันที่ทำรายการล่าสุด
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {paginatedItems.length > 0 ? (
                                paginatedItems.map((item, index) => {
                                  const globalIndex = (currentPageTab1 - 1) * itemsPerPageTab1 + index;
                                  // ใช้ Item_Id + WH_Id เป็น key เพื่อให้ unique (เพราะมีสินค้าเดียวกันในหลายคลัง)
                                  const rowKey = `${item.Item_Id || 'item'}_${item.WH_Id || 'wh'}`;
                                  return (
                                    <tr key={rowKey}>
                                      <td className="text-center">{globalIndex + 1}</td>
                                      <td className="text-center">
                                        {item.Item_Code}
                                      </td>
                                      <td className="text-left">
                                        {item.Item_Name}
                                      </td>
                                      <td className="text-end">
                                        {formatCurrency(item.Item_Onhand)}
                                      </td>
                                      <td className="text-center">
                                        {item.WH_Name}
                                      </td>
                                      <td className="text-center">
                                        {item.Last_STC_Date
                                          ? formatDateAndTime(item.Last_STC_Date)
                                          : ""}
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan={10}>
                                    <center>
                                      <h5>ไม่พบข้อมูล</h5>
                                    </center>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        {filteredItems.length > 0 && (
                          <div className="mt-3">
                            <Pagination
                              totalItems={filteredItems.length}
                              itemsPerPage={itemsPerPageTab1}
                              currentPage={currentPageTab1}
                              onPageChange={setCurrentPageTab1}
                              onItemsPerPageChange={(val) => {
                                setItemsPerPageTab1(val);
                                setCurrentPageTab1(1);
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`tab-pane fade ${
                    activeTab === 2 ? "show active" : ""
                  }`}
                  role="tabpanel"
                >
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header">
                        <div className="container-fluid">
                          <div
                            className="d-flex flex-row"
                            style={{
                              display: "grid",
                              gridTemplateColumns: "auto auto",
                              justifyContent: "space-between",
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <h4 className="card-title mb-0 me-2" style={{ whiteSpace: "nowrap" }}>
                                เลือกคลัง
                              </h4>
                              <select
                                style={{ width: "200px", whiteSpace: "nowrap" }}
                                className="form-select"
                                value={warehouseId || ""}
                                onChange={(e) => {
                                  onChangeWarehouse(e.target.value);
                                  localStorage.setItem(
                                    "stc-select-warehouse",
                                    e.target.value
                                  );
                                }}
                              >
                                <option value={""}>กรุณาเลือกคลัง</option>
                                <option value={"all"}>คลังทั้งหมด</option>
                                {whDataList.map((ware) => (
                                  <option key={ware.WH_Id} value={ware.WH_Id}>
                                    {ware.WH_Name}
                                  </option>
                                ))}
                              </select>

                              <h4 className="card-title mb-0 me-2 ms-3" style={{ whiteSpace: "nowrap" }}>เลือกปี</h4>
                              <select
                                style={{ width: "150px", whiteSpace: "nowrap" }}
                                className="form-select"
                                value={year || ""}
                                onChange={(e) => handleYearChange(e.target.value)}
                              >
                                {generateYearOptions().map((y) => (
                                  <option key={y} value={y.toString()}>
                                    {y}
                                  </option>
                                ))}
                              </select>

                              <h4 className="card-title mb-0 me-2 ms-3" style={{ whiteSpace: "nowrap" }}>เลือกเดือน</h4>
                              <select
                                style={{ width: "180px", whiteSpace: "nowrap" }}
                                className="form-select"
                                value={month || ""}
                                onChange={(e) => handleMonthChange(e.target.value)}
                              >
                                {generateMonthOptions().map((m) => (
                                  <option key={m.value} value={m.value}>
                                    {m.label}
                                  </option>
                                ))}
                              </select>

                              <h4 className="card-title mb-0 me-2 ms-3" style={{ whiteSpace: "nowrap" }}>ค้นหา</h4>
                              <input
                                type="text"
                                className="form-control"
                                style={{ width: "300px", whiteSpace: "nowrap" }}
                                placeholder="เลขเอกสาร, เอกสารอ้างอิง, หมายเหตุ"
                                value={searchItemHistory}
                                onChange={(e) => {
                                  setSearchItemHistory(e.target.value);
                                }}
                              />
                            </div>

                            <div className="mx-2">
                              <div className="d-flex">
                                {isFormItemHistoryLoaded &&
                                  !formItemHistory[0] && (
                                    <button
                                      className="btn text-white btn-lg"
                                      onClick={handleItemShow}
                                      style={{
                                        backgroundColor: "#E13F57",
                                        marginRight: "10px",
                                      }}
                                      disabled={
                                        warehouse_Id === "3" &&
                                        Emp_Position !== "1"
                                      }
                                    >
                                      <i
                                        className="fa fa-plus me-1"
                                        aria-hidden="true"
                                      ></i>{" "}
                                      ตั้งต้นสินค้า
                                    </button>
                                  )}
                                {formItemHistory[0] && (
                                  <button
                                    className="btn text-white btn-lg"
                                    onClick={handleWhShow}
                                    style={{
                                      backgroundColor: "#E13F57",
                                    }}
                                    disabled={
                                      warehouse_Id === "3" &&
                                      Emp_Position !== "1"
                                    }
                                  >
                                    <i
                                      className="fa fa-edit me-1"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    ปรับปรุงคลัง
                                  </button>
                                )}

                                <ItemModal
                                  formDetailList={[]}
                                  showItemModal={showItemModal}
                                  handleItemClose={handleItemClose}
                                  itemDataList={formItemList2}
                                  onRowSelectItem={handleBeginWarehouse}
                                />
                                <AdjustWhModal
                                  whDataList={whDataList}
                                  showWhModal={showWhModal}
                                  handleWhClose={handleWhClose}
                                  handleADJClose={handleADJClose}
                                  itemDetailModal={formItemHistory[0]}
                                  warehouseId={warehouseId}
                                  selectedItem={formItemList[selectedIndex]}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table
                            id="basic-datatables"
                            className="table table-striped table-hover"
                          >
                            <thead className="thead-dark">
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "4%" }}
                                >
                                  #
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  รหัสสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "23%" }}
                                >
                                  ชื่อสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "5%" }}
                                >
                                  ประเภท
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  จำนวน
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "7%" }}
                                >
                                  จำนวนคงเหลือ
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  วันที่ทำรายการ
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  ผู้ทำรายการ
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  คลังสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  เลขเอกสาร
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  เอกสารอ้างอิง
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  หมายเหตุ
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {paginatedItemHistory.length > 0 ? (
                                paginatedItemHistory.map((item, index) => {
                                  const globalIndex = (currentPageTab2 - 1) * itemsPerPageTab2 + index;
                                  return (
                                  <tr key={item.STC_Id}>
                                    <td className="text-center">{globalIndex + 1}</td>
                                    <td className="text-center">
                                      {item.Item_Code}
                                    </td>
                                    <td className="text-left">
                                      {item.Item_Name}
                                    </td>
                                    <td className="text-center">
                                      {item.Doc_Type}
                                    </td>
                                    <td className="text-end">
                                      {item.Doc_Type === "TO" ||
                                      item.Doc_Type === "AO" ||
                                      item.Doc_Type === "OUT"
                                        ? "-"
                                        : ""}
                                      {formatCurrency(item.STC_QTY)}
                                    </td>
                                    <td className="text-end">
                                      {formatCurrency(item.STC_Balance)}
                                    </td>
                                    <td className="text-center">
                                      {formatDateAndTime(item.STC_Date)}
                                    </td>
                                    <td className="text-center">
                                      {item.Emp_Name}
                                    </td>
                                    <td className="text-center">
                                      {item.WH_Name}
                                    </td>
                                    <td className="text-center">
                                      {item.Doc_No}
                                    </td>
                                    <td className="text-center">
                                      {item.Doc_NoRef &&
                                        item.Doc_NoRef.split("ยกเลิก").map(
                                          (part, index, array) => (
                                            <React.Fragment key={index}>
                                              {part}
                                              {index < array.length - 1 && (
                                                <span
                                                  style={{
                                                    color: "red",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  <strong>ยกเลิก</strong>
                                                </span>
                                              )}
                                            </React.Fragment>
                                          )
                                        )}
                                    </td>
                                    <td className="text-center">
                                      {item.STC_Remark || "-"}
                                    </td>
                                  </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan={12}>
                                    <center>
                                      <h5>ไม่พบข้อมูล</h5>
                                    </center>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        {filteredItemHistory.length > 0 && (
                          <div className="mt-3">
                            <Pagination
                              totalItems={filteredItemHistory.length}
                              itemsPerPage={itemsPerPageTab2}
                              currentPage={currentPageTab2}
                              onPageChange={setCurrentPageTab2}
                              onItemsPerPageChange={(val) => {
                                setItemsPerPageTab2(val);
                                setCurrentPageTab2(1);
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Modal ตั้งต้นสินค้ารายตัว */}
          {showInitialStockModal && selectedItemForInitial && (
            <div
              className="modal fade show"
              style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
              onClick={handleInitialStockClose}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div
                    className="modal-header"
                    style={{ backgroundColor: "#E13F57", color: "white" }}
                  >
                    <h5 className="modal-title">
                      <i
                        className="fa fa-plus-circle me-2"
                        aria-hidden="true"
                      ></i>
                      ตั้งต้นสินค้า
                    </h5>
                    <button
                      type="button"
                      className="btn-close btn-close-white"
                      onClick={handleInitialStockClose}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div
                      className="card mb-3"
                      style={{ backgroundColor: "#f8f9fa" }}
                    >
                      <div className="card-body">
                        <h6 className="card-subtitle mb-2 text-muted">
                          ข้อมูลสินค้า
                        </h6>
                        <p className="mb-1">
                          <strong>รหัสสินค้า:</strong>{" "}
                          {selectedItemForInitial.Item_Code}
                        </p>
                        <p className="mb-0">
                          <strong>ชื่อสินค้า:</strong>{" "}
                          {selectedItemForInitial.Item_Name}
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 mb-3">
                        <label className="form-label">
                          <strong>คลังสินค้า</strong>{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          value={warehouseId || ""}
                          onChange={(e) => {
                            const selectedWhId = e.target.value ? parseCurrency(e.target.value, 10) : null;
                            setWarehouseId(selectedWhId);
                          }}
                        >
                          <option value="">กรุณาเลือกคลัง</option>
                          {whDataList.map((wh) => (
                            <option key={wh.WH_Id} value={wh.WH_Id}>
                              {wh.WH_Name}
                            </option>
                          ))}
                        </select>
                        {!warehouseId && (
                          <small className="text-danger">
                            กรุณาเลือกคลัง
                          </small>
                        )}
                      </div>

                      <div className="col-12">
                        <label className="form-label">
                          <strong>จำนวนเริ่มต้น</strong>{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ระบุจำนวน"
                          value={initialQuantity}
                          onChange={(e) => {
                            const value = e.target.value.replace(/,/g, "");
                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                              setInitialQuantity(
                                value
                                  ? formatterWithCommas(parseFloat(value))
                                  : ""
                              );
                            }
                          }}
                          onFocus={selectOnFocus}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              document
                                .getElementById("submit-initial-stock-btn")
                                ?.click();
                              return;
                            }
                            onlyNumberKeyDown(e);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleInitialStockClose}
                    >
                      <i className="fa fa-times me-1" aria-hidden="true"></i>
                      ยกเลิก
                    </button>
                    <button
                      id="submit-initial-stock-btn"
                      type="button"
                      className="btn text-white"
                      style={{ backgroundColor: "#E13F57" }}
                      onClick={() => {
                        if (!warehouseId) {
                          getAlert("FAILED", "กรุณาเลือกคลังก่อน");
                          return;
                        }
                        const qty = parseFloat(parserStrict(initialQuantity));
                        if (!qty || qty <= 0) {
                          getAlert("FAILED", "กรุณาใส่จำนวนที่ถูกต้อง");
                          return;
                        }
                        handleInitialStockSubmit({
                          itemId: selectedItemForInitial.Item_Id,
                          itemCode: selectedItemForInitial.Item_Code,
                          itemName: selectedItemForInitial.Item_Name,
                          warehouseId: warehouseId,
                          quantity: qty,
                        });
                      }}
                    >
                      <i className="fa fa-check me-1" aria-hidden="true"></i>
                      ตกลง
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <style jsx global>{`
        .items-table .ant-table-content,
        .items-table .ant-table-body {
          overflow: auto !important;
          scrollbar-gutter: stable both-edges;
          scrollbar-width: thin;
        }
        .items-table .ant-table-content::-webkit-scrollbar,
        .items-table .ant-table-body::-webkit-scrollbar {
          height: 10px;
          width: 10px;
        }
        .items-table .ant-table-content::-webkit-scrollbar-thumb,
        .items-table .ant-table-body::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.3);
          border-radius: 8px;
        }
        .ant-table-wrapper .ant-table-thead > tr > th {
          background: #E13F57 !important;
          color: #fff;
          font-weight: 600;
        }
        .ant-table-tbody > tr.row-even > td {
          background: #ffffff;
        }
        .ant-table-tbody > tr.row-odd > td {
          background: oklch(0.98 0.01 71.17);
        }
        .ant-table-tbody > tr:hover > td {
          background: oklch(0.91 0.05 60.5) !important;
        }
        .ant-table-tbody > tr.ant-table-row-selected > td {
          background: oklch(0.91 0.05 60.5) !important;
        }
        .nav-tabs .nav-link.active {
          color: #E13F57 !important;
          border-bottom: 2px solid #E13F57 !important;
        }
        .nav-tabs .nav-link:hover {
          color: #E13F57 !important;
        }
      `}</style>
    </>
  );
}

export default Form;
